import { useEffect } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import { SECOND } from 'time-constants';

import { liveVideoPlayerState } from '@store';

const getMediaTailorAdInfo = async videoData => {
  const { live, session_id } = videoData ?? {};

  if (session_id) {
    const trackingUrl = `${live?.mediatailor_endpoint.replace('master', 'tracking')}${session_id}`;

    const { data: trackingData } = await axios.get(trackingUrl);

    if (!trackingData) {
      throw new Error('Unable to retrieve ad tracking information');
    }

    return trackingData;
  }
};

export const useGetMediaTailorAdInfo = () => {
  const [{ data: videoData, stopped }, setLiveVideoState] = useRecoilState(liveVideoPlayerState);

  const { data: adTrackingData } = useQuery('getMediaTailorAdInfo', () => getMediaTailorAdInfo(videoData), {
    enabled: !stopped && Boolean(videoData),
    refetchOnWindowFocus: false,
    refetchInterval: 6 * SECOND,
    retry: false,
  });

  useEffect(() => {
    setLiveVideoState(currentState => ({ ...currentState, adTrackingData }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adTrackingData]);
};
